import { AppConfig } from "@/utils/AppConfig";
import { formatMoneyForInput } from "@/utils/helpers";
import { useState } from "react";
import { MdOutlineDelete } from "react-icons/md";

interface OptionPriceInputProps {
  value: number | undefined;
  onDelete: () => void;
  onChange: (value: number | undefined) => void;
  error?: string;
  label: string;
  placeholder: string;
}

export const OptionPriceInput = ({
  value,
  onDelete,
  onChange,
  error,
  label,
  placeholder,
}: OptionPriceInputProps) => {
  const [isFoucused, setIsFocused] = useState(false);
  
  return (
    <div className="flex w-full flex-col gap-2 self-start sm:w-[150px]">
      <label className="text-sm font-semibold capitalize text-gray-700">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <div dir="rtl" className="relative size-full">
          <input
            value={value === undefined ? "" : isFoucused ? value : formatMoneyForInput(value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            type="number"
            placeholder={placeholder}
            className="size-full h-9 rounded-md border border-gray-300 pe-[41px] text-center"
            onChange={(e) =>
              onChange(e.target.value === "" ? undefined : +e.target.value)
            }
          />
          <span className="text absolute end-[1px] top-1/2 flex h-[97%] w-[40px] -translate-y-1/2 items-center justify-center rounded-e-md bg-gray-100">
            {AppConfig.currency.icon()}
          </span>
        </div>
        <button
          onClick={onDelete}
          type="button"
          className="self-end rounded bg-red-500 px-4 py-2 font-bold text-white hover:bg-red-700"
        >
          <MdOutlineDelete size={20} />
        </button>
      </div>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};
